import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import Show from "../../../utils/show.component";
import { required, number, fieldLength16, zipCodeCheck } from "../../../utils/formValidators";
import { cvvToolTip } from "../../../utils/toolTips";
import {
  renderField,
  renderMoneyField,
  renderMaskedField,
  renderCheckboxField,
} from "../../../utils/renderField";
import { convenienceFee } from "../../../utils/content";
import { Row, Col, FormGroup } from "react-bootstrap";

export class LoanPaymentDebitFormComponent extends Component {
  constructor(props) {
    super(props);
    this.amount = "0";
    this.submitForm = this.submitForm.bind(this);
  }

  submitForm(e) {
    this.props.submitForm(this.props.form);
  }

  getPrincipalOnly = () => {
    return (
      this.props.formValues !== undefined &&
      this.props.formValues.hasOwnProperty("values") &&
      this.props.formValues.values.isPrincipalOnlyDebit === true
    );
  };

  componentDidUpdate() {
    if (this.props.principalPayoffSwitch) {
      // Do your one-time principal only changed to payoff stuff here

      this.props.change("isPrincipalOnlyDebit", false);
      this.props.togglePrincipalPayoffSwitch(false);
    }
  }

  render() {
    const { pristine, submitting, handleSubmit, change, show } = this.props;
    const isPrincipalOnly = this.getPrincipalOnly();

    if (this.props.formValues !== undefined && this.props.formValues.values) {
      this.amount = this.props.formValues.values.amount ? this.props.formValues.values.amount : "0";
    }
    return (
      <form onSubmit={handleSubmit(this.submitForm)} className={show ? "" : "hide"}>
        <Show condition={this.props.ChargeOffIsRequired !== true}>
          <div className="row">
            <div className="payment-restrictions">
              <strong>${convenienceFee} convenience fee</strong> for debit card payments
            </div>
          </div>
        </Show>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <Field
                label="Name on Card"
                name="nameOnCard"
                component={renderField}
                validate={[required]}
                type="text"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <Field
                component={renderMaskedField}
                label={this.props.paymentType == "Appraisal" ? "Card Number" : "Debit Card Number"}
                mask={[
                  /[0-9]/,
                  /[0-9]/,
                  /[0-9]/,
                  /[0-9]/,
                  " ",
                  /[0-9]/,
                  /[0-9]/,
                  /[0-9]/,
                  /[0-9]/,
                  " ",
                  /[0-9]/,
                  /[0-9]/,
                  /[0-9]/,
                  /[0-9]/,
                  " ",
                  /[0-9]/,
                  /[0-9]/,
                  /[0-9]/,
                  /[0-9]/,
                ]}
                name="account_nbr"
                validate={[number, required, fieldLength16]}
                inputMode="numeric"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-lg-6">
            <div className="form-group">
              <Field
                component={renderMaskedField}
                mask={[/[0-9]/, /[0-9]/, "/", /[0-9]/, /[0-9]/]}
                label="Exp Date"
                name="exp_date"
                placeholder="MM/YY"
                validate={[required, number]}
                inputMode="numeric"
              />
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className="form-group">
              <Field
                component={renderField}
                label="CVC"
                name="cvv2"
                tooltip={cvvToolTip}
                validate={[required, number]}
                inputMode="numeric"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-lg-6">
            <div className="form-group">
              <Field
                component={renderField}
                label="Zip Code"
                name="zip_code"
                inputMode="numeric"
                validate={[required, number, zipCodeCheck]}
              />
            </div>
          </div>
          <Show condition={this.props.paymentType !== "Appraisal"}>
            <div className="col-12 col-lg-6">
              <div className="form-group">
                <Field
                  component={renderMoneyField}
                  label="Payment Amount"
                  name="amount"
                  validate={[required]}
                  changeFunction={change}
                  inputMode="decimal"
                />
              </div>
            </div>
          </Show>
          <Show condition={this.props.paymentType == "Appraisal"}>
            <div className="col-12 col-lg-6">
              <div className="form-group">
                <label>Payment Amount</label>
                <label>{this.props.amountDue}</label>
              </div>
            </div>
          </Show>
        </div>
        {/* If the amount they're paying is greater than the amount due, warn them that it will not apply towards next month */}
        <div
          className={
            !isPrincipalOnly && Number(this.amount.replace(/[$,]/g, "")) > this.props.amountDue
              ? "row show"
              : "hide"
          }
        >
          <div className="col-12">
            <div className="alert primary">
              Payment in excess of the amount due will not affect next month's payment. Your payment
              will be applied to daily accrued interest and principal.
            </div>
          </div>
        </div>

        {/* Hide principal only payment checkbox for now */}
        <Show condition={false}>
          <Show condition={isPrincipalOnly}>
            <div className="col-12 p-0">
              <div className="alert primary">
                Payments made towards the principal only will not affect the next month’s payment.
              </div>
            </div>
          </Show>

          <Show
            condition={
              new Date(this.props.nextDueDate) >= new Date() || this.props.nextDueDate == null
            }
          >
            <Field
              label="Apply Payment Amount to Principal Only"
              name="isPrincipalOnlyDebit"
              type="checkbox"
              id="isPrincipalOnlyDebit"
              component={renderCheckboxField}
            />
          </Show>
        </Show>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <button disabled={submitting} className="button primary full" type="submit">
                Review Payment
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

//Connect to Redux store
const LoanPaymentDebitForm = reduxForm({
  form: "LoanPaymentDebit",
  destroyOnUnmount: false,
  initialValues: { isPrincipalOnlyDebit: false },
})(LoanPaymentDebitFormComponent);

export default LoanPaymentDebitForm;



// WEBPACK FOOTER //
// ./src/components/forms/loan-payment-debit/loan-payment-debit-form.component.js